import { render, staticRenderFns } from "./TerminosYCondicionesComponent.vue?vue&type=template&id=15a4cb72&"
import script from "./TerminosYCondicionesComponent.vue?vue&type=script&lang=ts&"
export * from "./TerminosYCondicionesComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports